import Texts from '../localization/Texts';

const Languages = Texts.EN.searchBox.languages; //TODO: read current language

const lang = (name, tag) => {return {name, tag}};
const res = Object.keys(Languages).map((key) => {
    return lang(Languages[key], key);
});

export default res;



// WEBPACK FOOTER //
// ./src/assets/SupportedLanguages.js